export const initialAuthState = {
  error: null,
  isAuthenticated: false,
};

export type AuthState = {
  error: Error | null;
  isAuthenticated: boolean;
};
